import type { AgeGroup } from "@/lib/age-group/store";
import { NPS_SURVEY_FLAG_KEY } from "@/lib/nps/constants";

export { NPS_SURVEY_FLAG_KEY };

/**
 * Fail-closed: eligible only when PostHog has explicitly enabled the flag.
 * `undefined` / `null` mean flags are not ready yet — do not show NPS.
 */
export function isNpsSurveyFlagOn(flagEnabled: boolean | null | undefined): boolean {
  return flagEnabled === true;
}

/**
 * Known grownups always enter the NPS cohort (100%).
 * Kids and unknown still require the PostHog `nps-survey` ~10% flag (fail-closed).
 */
export function isInNpsSurveyCohort(
  flagEnabled: boolean | null | undefined,
  ageGroup: AgeGroup | null
): boolean {
  if (ageGroup === "grownup") return true;
  return isNpsSurveyFlagOn(flagEnabled);
}
